module.exports = __webpack_public_path__ + "img/NavigationBarAccountIcon.9cb098dd.png";